import clsx from "clsx";
import Link, { type LinkProps } from "next/link";
import { Button as AriaButton, type ButtonProps as AriaButtonProps } from "react-aria-components";

import { uiOutlineClass } from "@/components/ui/global/outline";

type InlineIconButtonProps = Omit<AriaButtonProps, "children"> & {
  label: string;
  icon: React.FC<React.SVGProps<SVGSVGElement>>;
  link?: LinkProps & { target?: string };
  iconClassName?: string;
};

export const InlineIconButton = ({ label, icon: Icon, link, iconClassName, ...props }: InlineIconButtonProps) => {
  const Component: any = link ? Link : AriaButton;

  return (
    <Component
      {...props}
      {...link}
      isDisabled={props.isDisabled}
      className={clsx(
        "inline-flex rounded-button-rounding text-interactive-icon-idle",
        "active:text-interactive-icon-pressed",
        "hover:text-interactive-icon-hover",
        "focus-visible:outline-interactive-icon-focus",
        "disabled:text-interactive-icon-disabled",
        uiOutlineClass,
        props.className,
      )}
      aria-label={label}
    >
      <Icon className={clsx("h-6 w-6", iconClassName)} />
    </Component>
  );
};
